// extracted by mini-css-extract-plugin
module.exports = {"cfModuleBody":"Modules_cfModuleBody__31apQ","cfModuleContent":"Modules_cfModuleContent__3jFPk","cfDictionaryContent":"Modules_cfDictionaryContent__2hb21"};